import React from "react";
import { ClientReportType } from "../../../../types/ClientReportType";
import { openSendClientReportModal } from "../../client-report-send";

export type SendClientReportOptions = {
    adviserMessage: string,
    emailAddressesToNotify: string[],
    isNotifiedViaDashboard: boolean,
    isNotifiedViaEmail: boolean,
    mailMessage: MailMessage | null
    mediaType: number
};

const ReportPublishContext = React.createContext<{
    openSendOptions: (options?: SendClientReportOptions | null) => Promise<SendClientReportOptions>,
    sendOptions: SendClientReportOptions | null
}>({
    openSendOptions: () => new Promise((resolve, reject) => reject()),
    sendOptions: null
});

export const useReportSendOptions = () => React.useContext(ReportPublishContext);

export const ReportPublishProvider = ({
    children,
    data = null
} : Readonly<{
    children: React.ReactNode,
    data: ClientReportType | null
}>) => {
    const [sendOptions, setSendOptions] = React.useState<SendClientReportOptions | null>(null);

    const openSendOptions = (options: SendClientReportOptions | null = null) : Promise<SendClientReportOptions> => new Promise((resolve, reject) => {
        return openSendClientReportModal(data!, options ?? sendOptions)
            .then((form: SendClientReportOptions) => {
                setSendOptions(() => form);
                resolve(form);
            })
            .catch(() => reject());
    });

    return (
        <ReportPublishContext.Provider value={{
            openSendOptions,
            sendOptions
        }}>
            {children}
        </ReportPublishContext.Provider>
    );
};